module.exports = __webpack_public_path__ + "img/auth3.97c0795b.png";